<template>
  <div class="my-5 mx-5 my-sm-15 mx-sm-10">
    <v-row>
      <v-col>
        <AvailableQuizzes />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AvailableQuizzes from "../components/AvailableQuizzes.vue";

export default {
  name: "QuizzesPage",
  components: { AvailableQuizzes },
};
</script>
